import React, { useContext } from 'react'
import styled from 'styled-components'
import { IUser } from '@giphy/js-types'
import { ContentBlockContext } from '../context'

const IconBase = styled.div`
    height: 22px;
    margin-left: auto;
    position: relative;
    width: 22px;
`

const Icon = styled(IconBase)`
    color: #fff;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
`

const Avatar = styled(IconBase)`
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
`

const getSmallAvatar = avatar => {
    if (!avatar) return ''

    const ext = avatar
        .split('.')
        .pop()
        .toLowerCase()
    return avatar.replace(`.${ext}`, `/80h.${ext}`)
}

type Props = {
    user?: IUser
}

const ContentBlockIcon = ({ user }: Props) => {
    const { iconClassName } = useContext(ContentBlockContext)
    if (iconClassName) {
        return <Icon className={iconClassName} />
    }
    if (user) {
        return <Avatar style={{ backgroundImage: `url(${getSmallAvatar(user.avatar_url)})` }} />
    }
    return null
}

export default ContentBlockIcon
